/* download.js: render the download buttons from the R2 update manifest (releases/latest.json — the
   same file the in-app updater polls, written by release.yaml's publish job). Zero deps, no framework.

   Reading it cross-origin needs a CORS rule on the R2 bucket allowing the shop origin; without one the
   fetch fails and we fall back to a plain link at the manifest's base, so the page is never a dead end. */
(function () {
  var el = document.getElementById("jiggly-download");
  if (!el) return;
  var base = (el.getAttribute("data-base") || "").replace(/\/+$/, "");
  var fallback = el.getAttribute("data-fallback") || "";

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  // The installers are GB-scale (~1.3 GB), so plain MB reads as a wall of digits ("1319 MB").
  function size(bytes) {
    var n = Number(bytes);
    if (!(n > 0)) return "";
    return n >= 1073741824 ? (n / 1073741824).toFixed(1) + " GB"
                           : (n / 1048576).toFixed(0) + " MB";
  }

  // Manifest keys are written by release.yaml: windows-x86_64 / darwin-aarch64 / darwin-x86_64 /
  // linux-x86_64. Browsers don't reliably expose Mac CPU arch, so both Macs are offered and Apple
  // Silicon leads — it's the common case, and picking wrong here only costs a click.
  var LABELS = {
    "windows-x86_64": "Windows",
    "darwin-aarch64": "macOS (Apple Silicon)",
    "darwin-x86_64": "macOS (Intel)",
    "linux-x86_64": "Linux"
  };

  function detect() {
    var ua = navigator.userAgent || "";
    if (/Windows|Win64|Win32/i.test(ua)) return { os: "Windows", keys: ["windows-x86_64"] };
    if (/Macintosh|Mac OS X/i.test(ua)) return { os: "macOS", keys: ["darwin-aarch64", "darwin-x86_64"] };
    if (/Linux|X11/i.test(ua) && !/Android/i.test(ua)) return { os: "Linux", keys: ["linux-x86_64"] };
    return { os: "", keys: [] };
  }

  function card(key, p, primary) {
    return '<a class="btn' + (primary ? " cherry" : " alt") + '" href="' + esc(p.url) + '">'
      + esc(LABELS[key] || key) + "</a>"
      + '<span class="dl-meta">' + esc(size(p.size)) + "</span>";
  }

  // Deliberately does NOT fall back to `base`: that's the bucket root, and R2 has no directory index,
  // so it would hand the user a NoSuchKey page exactly when something is already broken. With no
  // fallback link configured we say so plainly and let the section's support note carry the recovery.
  function bail(msg) {
    el.innerHTML = '<div class="card"><p class="muted">' + esc(msg) + "</p>"
      + (fallback ? '<a class="btn cherry" href="' + esc(fallback) + '">Downloads</a>' : "") + "</div>";
  }

  if (!base) { bail("Downloads aren't configured yet."); return; }

  fetch(base + "/releases/latest.json", { cache: "no-cache" })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (man) {
      var plats = (man && man.platforms) || {};
      var keys = Object.keys(plats);
      if (!keys.length) { bail("No builds published yet."); return; }

      var d = detect();
      var mine = d.keys.filter(function (k) { return plats[k]; });
      var rest = keys.filter(function (k) { return mine.indexOf(k) === -1; });

      // A release can ship without every platform (the Linux build is allowed to fail in CI), so a
      // visitor's OS may genuinely have no installer. Say that, and DON'T promote another OS's build
      // into the primary slot — a Linux visitor being handed a big "macOS" button reads as broken.
      var html = "";
      if (!mine.length && d.os) {
        html += '<p class="dl-none">No ' + esc(d.os) + " build in this release yet.</p>";
      }
      html += '<div class="dl-primary">';
      (mine.length ? mine : keys).forEach(function (k, i) {
        html += card(k, plats[k], mine.length ? i === 0 : false);
      });
      html += "</div>";

      if (mine.length && rest.length) {
        html += '<div class="dl-others"><span class="muted">Other platforms:</span>';
        rest.forEach(function (k) { html += card(k, plats[k], false); });
        html += "</div>";
      }
      if (man.version) {
        html += '<p class="dl-ver muted">Version ' + esc(man.version) + "</p>";
      }
      el.innerHTML = html;
    })
    .catch(function () {
      bail("Couldn't reach the download server just now.");
    });
})();
